/* Nifty Gift (NG) addition to stock Dawn: a card swatch swaps the card image to that colour. */
document.addEventListener('click', function (event) {
  var swatch = event.target.closest('.ng-swatch');
  if (!swatch) return;
  event.preventDefault();
  var card = swatch.closest('.card-wrapper');
  var image = card && card.querySelector('.card__media img');
  if (image && swatch.dataset.src) {
    image.src = swatch.dataset.src;
    image.srcset = swatch.dataset.srcset || '';
  }
  card.querySelectorAll('.ng-swatch').forEach(function (s) { s.classList.toggle('is-active', s === swatch); });
});